import { DEFAULT_LAYOUT_STYLE } from "./constants/ThemeConstants";

export const THEME_CONFIG = {
	navCollapsed: true,
	dataHover: true,
	topNavCollapsed: false,
	layoutStyle: DEFAULT_LAYOUT_STYLE,
};